"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgGoogleColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 0h-27A1.5 1.5 0 000 1.5v27A1.5 1.5 0 001.5 30h27a1.5 1.5 0 001.5-1.5v-27A1.5 1.5 0 0028.5 0z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5.75h-27a.75.75 0 00-.75.75v27c0 .414.336.75.75.75h27a.75.75 0 00.75-.75v-27a.75.75 0 00-.75-.75z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.48 15.153c0-.478-.043-.938-.123-1.38H15v2.61h3.633a3.105 3.105 0 01-1.347 2.038v1.694h2.181c1.277-1.175 2.013-2.906 2.013-4.962z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 21.75c1.823 0 3.35-.604 4.467-1.635l-2.181-1.694c-.605.405-1.378.644-2.286.644-1.758 0-3.246-1.187-3.777-2.783H8.968v1.75A6.747 6.747 0 0015 21.75z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.223 16.282A4.057 4.057 0 0111.011 15c0-.445.077-.877.212-1.283V11.97H8.968a6.748 6.748 0 000 6.062l2.255-1.748z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 10.935c.991 0 1.88.34 2.58 1.01l1.936-1.937C18.347 8.918 16.82 8.25 15 8.25a6.747 6.747 0 00-6.032 3.719l2.255 1.748c.53-1.595 2.019-2.782 3.777-2.782z",
    fill: "#EA4335"
  }));
}
var _default = SvgGoogleColor;
exports["default"] = _default;